!function(window) {
// babel-polyfills
// require("babel-polyfill");

jQuery.cookie = function (name, value, options) {
	if (typeof value != "undefined") {
		options = options || {};
		if (value === null) {
			value = "";
			options.expires = -1
		}
		var expires = "";
		if (options.expires && (typeof options.expires == "number" || options.expires.toUTCString)) {
			var date;
			if (typeof options.expires == "number") {
				date = new Date();
				date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000))
			} else {
				date = options.expires
			}
			expires = "; expires=" + date.toUTCString()
		}
		var path = options.path ? "; path=" + (options.path) : "";
		var domain = options.domain ? "; domain=" + (options.domain) : "";
		var secure = options.secure ? "; secure" : "";
		document.cookie = [name, "=", encodeURIComponent(value), expires, path, domain, secure].join("")
	} else {
		var cookieValue = null;
		if (document.cookie && document.cookie != "") {
			var cookies = document.cookie.split(";");
			for (var i = 0; i < cookies.length; i++) {
				var cookie = jQuery.trim(cookies[i]);
				if (cookie.substring(0, name.length + 1) == (name + "=")) {
					cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
					break
				}
			}
		}
		return cookieValue
	}
};

require("../jquery-extended-arctur")(jQuery);




// URL plugin

jQuery.url = function () {
	var segments = {};
	var parsed = {};
	var options = {
		url: window.location,
		strictMode: false,
		key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
		q: {
			name: "queryKey",
			parser: /(?:^|&)([^&=]*)=?([^&]*)/g
		},
		parser: {
			strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
			loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
		}
	};
	var parseUri = function () {
		var str = decodeURI(options.url);
		var m = options.parser[options.strictMode ? "strict" : "loose"].exec(str);
		var uri = {};
		var i = 14;
		while (i--) {
			uri[options.key[i]] = m[i] || ""
		}
		uri[options.q.name] = {};
		uri[options.key[12]].replace(options.q.parser, function ($0, $1, $2) {
			if ($1) {
				uri[options.q.name][$1] = $2
			}
		});
		return uri
	};
	var key = function (key) {
		if (!parsed.length) {
			setUp()
		}
		if (key == "base") {
			if (parsed.port !== null && parsed.port !== "") {
				return parsed.protocol + "://" + parsed.host + ":" + parsed.port + "/"
			} else {
				return parsed.protocol + "://" + parsed.host + "/"
			}
		}
		return (parsed[key] === "") ? null : parsed[key]
	};
	var param = function (item) {
		if (!parsed.length) {
			setUp()
		}
		return (parsed.queryKey[item] === null) ? null : parsed.queryKey[item]
	};
	var setUp = function () {
		parsed = parseUri();
		getSegments()
	};
	var getSegments = function () {
		var p = parsed.path;
		segments = [];
		segments = parsed.path.length == 1 ? {} : (p.charAt(p.length - 1) == "/" ? p.substring(1, p.length - 1) : p.substring(1)).split("/")
	};
	return {
		setMode: function (mode) {
			strictMode = mode == "strict" ? true : false;
			return this
		},
		setUrl: function (newUri) {
			options.url = newUri === undefined ? window.location : newUri;
			setUp();
			return this
		},
		segment: function (pos) {
			if (!parsed.length) {
				setUp()
			}
			if (pos === undefined) {
				return segments.length
			}
			return (segments[pos] === "" || segments[pos] === undefined) ? null : segments[pos]
		},
		attr: key,
		param: param
	}
}();


var map;
window.initMap = function() {
	var myLatlng = new google.maps.LatLng(46.3159441,13.4942649);
	map = new google.maps.Map(document.getElementById('boka-map'), {
		center: {lat:46.3159441,lng:13.4942649},
		zoom: 13,
		mapTypeControl: false,
		streetViewControl: false,
		zoomControlOptions: {
			style: google.maps.ZoomControlStyle.SMALL,
			position: google.maps.ControlPosition.LEFT_BOTTOM
		},
		styles:[
			{
				"featureType": "administrative",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"color": "#444444"
					}
				]
			},
			{
				"featureType": "administrative.country",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "administrative.country",
				"elementType": "geometry",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#464242"
					},
					{
						"weight": "2"
					}
				]
			},
			{
				"featureType": "administrative.country",
				"elementType": "labels",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "administrative.country",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "administrative.locality",
				"elementType": "labels",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "administrative.locality",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [
					{
						"color": "#FFFFFF"
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "off"
					},
					{
						"hue": "#FF0000"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "all",
				"stylers": [
					{
						"saturation": -100
					},
					{
						"lightness": 45
					},
					{
						"visibility": "on"
					},
					{
						"color": "#D3D3D3"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#CFCFCF"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "labels",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "simplified"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry",
				"stylers": [
					{
						"gamma": "1.80"
					},
					{
						"visibility": "on"
					},
					{
						"color": "#CFCFCF"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "labels",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"saturation": "-72"
					},
					{
						"lightness": "45"
					},
					{
						"gamma": "1.16"
					},
					{
						"color": "#CFCFCF"
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry",
				"stylers": [
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "all",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "all",
				"stylers": [
					{
						"color": "#3DCEDE"
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#52D7E0"
					},
					{
						"weight": "0.01"
					},
					{
						"gamma": "1"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"weight": "1.37"
					},
					{
						"hue": "#00E6FF"
					},
					{
						"gamma": "1.59"
					},
					{
						"lightness": "-21"
					},
					{
						"saturation": "17"
					},
					{
						"visibility": "on"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"visibility": "off"
					},
					{
						"color": "#7B3535"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "labels",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "labels.text",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"color": "#6D3C3C"
					},
					{
						"visibility": "off"
					}
				]
			}
		]

	});

	var marker = new google.maps.Marker({
		position: myLatlng,
		title:"Hotel Boka",
		icon: '/images/backgrounds/icons/marker.svg',
	});

	marker.setMap(map);
}


//global variables for responsivness

var urlDirFull = jQuery.url.attr("directory");
var pageLng = null;


function initilizeLanguageSettings() {
	/* --- language settings --- */

	var htmlLang = $('html').attr('lang');
	if (htmlLang == 'sl') {
		pageLng = 'slo';
	} else if (htmlLang == 'it') {
		pageLng = 'ita';
	} else if (htmlLang == 'de') {
		pageLng = 'deu';
	} else if (htmlLang == 'hr') {
		pageLng = 'hrv';
	} else {
		pageLng = 'eng';
	}

	if (pageLng == 'slo' || pageLng == 'hrv') {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Nedelja', 'Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota'];
		Date.abbrDayNames = ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'];
		Date.monthNames = ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december'];
		Date.abbrMonthNames = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Prejšnje leto',
			TEXT_PREV_MONTH: 'Prejšnji mesec',
			TEXT_NEXT_YEAR: 'Naslednje leto',
			TEXT_NEXT_MONTH: 'Naslednji mesec',
			TEXT_CLOSE: 'Zapri',
			TEXT_CHOOSE_DATE: 'Izberi datum'
		}
	} else {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		Date.abbrDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		Date.monthNames = ['January', 'February', 'March', 'April', 'May', 'Jun', 'Julay', 'August', 'September', 'October', 'November', 'December'];
		Date.abbrMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Previews year',
			TEXT_PREV_MONTH: 'Previews month',
			TEXT_NEXT_YEAR: 'Next year',
			TEXT_NEXT_MONTH: 'Next month',
			TEXT_CLOSE: 'Close',
			TEXT_CHOOSE_DATE: 'Select date'
		}
	}
}

function viewport() {
	var e = window,
		a = 'inner';
	if (!('innerWidth' in window)) {
		a = 'client';
		e = document.documentElement || document.body;
	}
	return {
		width: e[a + 'Width'],
		height: e[a + 'Height']
	};
}

/**Functions that dont require document to be ready */
initilizeLanguageSettings();


jQuery(document).ready(function () {

	var options = {
		viewport: {
			size: viewport,
			definition: {
				xs: 480,
				sm: 768,
				md: 992,
				lg: 1230
			}
		}
	}

	

	/* --- anchor click scrolling --- */
	$('a[href^="#"]').click(function (e) {
		// scroll to anchor if there is actually more after the # sign in the link
		if ($(this).attr('href').length > 1) {
			var scrollToElementName = $(this).attr('href').substr($(this).attr('href').indexOf("#") + 1);
			scrollTo = $("a[name=" + scrollToElementName + "]").offset().top;
			$('html, body').animate({
				scrollTop: scrollTo
			}, 500);
			e.preventDefault();
		}
	});


	/* --- Calendar --- */
	function initCalendar() {
		// advance a month
		var strId = $('#calendar-response').attr('class');

		if (strId) {
			// Get language
			var aLng = strId.split('_');
			var lng = aLng[1];

			// Load next month
			$("#cal-next-month").click(function (e) {
				var cName = $("#cal-next-month").attr("class");
				var y = cName.substr(6, 4);
				var m = cName.substr(10, 2);
				$("#calendar-response").load("/util/ajaxresponse.php?lng=" + lng, {
					'func': 'outputCalendar',
					'y': y,
					'm': m,
					'eventsStrId': strId
				}, function () {
					initCalendar();
				});
				e.preventDefault();
			});

			// backtrack a month
			$("#cal-prev-month").click(function (e) {
				var cName = $("#cal-prev-month").attr("class");
				var y = cName.substr(6, 4);
				var m = cName.substr(10, 2);
				$("#calendar-response").load("/util/ajaxresponse.php?lng=" + lng, {
					'func': 'outputCalendar',
					'y': y,
					'm': m,
					'eventsStrId': strId
				}, function () {
					initCalendar();
				});
				e.preventDefault();
			});
		}
	}


	function submitHelper() {
		$('.submit-helper').on('click', function(ev) {
			ev.preventDefault();
			ev.stopPropagation();

			$(this).closest('form').submit();
		});
	}
	submitHelper();


	function placeMarker(map, location, type, tooltip, url) {
		var marker = new google.maps.Marker({
			position: location,
			icon: '/images/markers/'+type+'.png',
			map: map,
			draggable: false
		});
		
		var tooltipHtml = '<div class="explore-karst-tooltip"><a href="'+url+'">'+tooltip+'</a></div>';
		
		var infowindow = new google.maps.InfoWindow({
			content: tooltipHtml
		});
		
		google.maps.event.addListener(marker, 'click', function() {
		   infowindow.open(map,marker);
		});
		
		return marker;
	}
	
	$('.open-main-menu').on('click', function(e){
		$('.line-1, .line-2').toggleClass('move');
		
		const scrollContainer = $("body").getNiceScroll()[0];
		
		if($('.main-menu').hasClass('open-menu')){
			$('.main-menu').removeClass('open-menu');
			scrollContainer.locked = false;
		}else{
			$('.main-menu').addClass('open-menu');
			scrollContainer.locked = true;
		}
		if($('.booking').hasClass('open')){
			$('.booking').removeClass('open');
		}
	});
	
	$('.open-booking').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		$('.booking').toggleClass('open');
		
		$('header').removeClass('hide');
		
		const scrollContainer = $("body").getNiceScroll()[0];
		if($('.booking').hasClass('open')){
			scrollContainer.locked = true;
		}else{
			scrollContainer.locked = false;
		}
	});
	
	$('.booking #close').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		$('.booking').removeClass('open');
		
		const scrollContainer = $("body").getNiceScroll()[0];
		scrollContainer.locked = false;
	});
	
	function setSpecialOffer(){
		if(viewport().width < 991){
			$('.showSpecialOffer').on('click', function(e){
				e.preventDefault();
				$('.floatings, .specialOffer_content').show().css('height','auto');
			});
			$('.closeSpecial').on('click', function(e){
				e.preventDefault();
				$('.floatings').fadeOut();
				$('.specialOffer_content').hide().css('height','100px');
			});
		} else {
			$('.specialOffer').on('click', function(e){
				if($(this).hasClass('open')){
					$('.he', this).show();
					$(this).removeClass('open');
					$('.specialOffer_content').css('display', 'none');
					$('.floating-btn').css('height','100px');
				} else {
					$('.he', this).hide();
					$(this).addClass('open');
					$('.specialOffer_content').css('display', 'block');
					$('.floating-btn').css('height','auto');
				}
			});
		}
	}
	setSpecialOffer();
	function resposnivTableWrapper(){
		$("table").each(function () {
			$(this).wrap('<div class="table-wrapper"></div>').parent();
		});
	}
	resposnivTableWrapper();
	
	function fixMobileTables() {
		// Wrap the tables, which are too wide with an overflow div
		
		$("table").each(function () {
			var pageWidth = viewport().width;
			if (pageWidth <= 990) {
				$('.table-wrapper').css({
					'width': '100%',
					'overflow-x': 'auto'
				});
				$(this).css({'width': '100%'});
			}else{
				$('.table-wrapper').css({
					'width': 'auto',
					'overflow': 'visible'
				});
				$(this).css({'width': '100%'});
			}
		});
	}
	fixMobileTables();

	$('iframe').each(function(index, item){
		if(!$(item).hasClass('no-resize')){
			$(item).wrap('<div class="embed-responsive embed-responsive-16by9">');
			$(item).addClass('embed-responsive-item');
		}
	});


	//preverja ie brskalnik in naloži drugi stil
	var ua = window.navigator.userAgent;
	var isIE = /MSIE|Trident/.test(ua);
	//var isSafari = /^((?!chrome|android).)*safari/i.test(ua);

	function loadNiceScroll(){
		/*https://github.com/Tolc/jquery.nicescroll/tree/6876279cb895bc6ad892c71f8a327dce85e18e9b   -   konfiguracijski parametri */
		if (!isIE && viewport().width > 991) {
			$("body").niceScroll({
				scrollspeed:20,
				mousescrollstep:70,
				emulatetouch: true,
				cursorwidth:"0px",
				cursorborder:"0px",
				//autohidemode: "hidden"
				enablekeyboard: false,
			});
		}
	}
	
	document.querySelector("body").onkeydown = function(e) {
		if (viewport().width > 991) {
			if(e.code == 'Home'){
				window.scrollTo(0, 0);
			}
			if(e.code == 'End'){
				window.scrollTo(document.body.scrollWidth, 0);
			}
			if(e.code == 'PageUp'){
				window.scrollBy(-document.body.clientWidth, 0);
			}
			if(e.code == 'PageDown'){
				window.scrollBy(document.body.clientWidth, 0);
			}
			if(e.code == 'ArrowUp'|| e.code == 'ArrowLeft' ){
				window.scrollBy(-150, 0);
			}
			if(e.code == 'ArrowDown' || e.code == 'ArrowRight'){
				window.scrollBy(150, 0);
			}
		}
	};
	
	var video = document.getElementById("backgroundvid");
	let videoStarted = true;
	function stopVideo(){
		if(videoStarted){
			video.pause();
			videoStarted = false;
			video.style.display = "none";
		}
	}
	function startVideo(){
		if(!videoStarted){
			video.play();
			videoStarted = true;
			video.style.display = "block";
		}
	}
	
	if(video != null){
		var lastScrollLeft = $(document).scrollLeft();
		var lastScrollDown = $(document).scrollTop();
		if (viewport().width > 991 && lastScrollLeft > document.body.clientWidth) {
			stopVideo();
		}
	}
	
	function stopStartVideo(){
		if(video != null){
			var documentScrollLeft = $(document).scrollLeft();
			var documentScrollDown = $(document).scrollTop();
			var curHeight = window.innerHeight;
			var curWidth = window.innerWidth;
			
			if (documentScrollLeft > curWidth || documentScrollDown > curHeight) {
				stopVideo();
			}else{
				startVideo();
			}
		}
	}
	
	function hideMenuBar(){
		
		var documentScrollLeft = $(document).scrollLeft();
		var documentScrollDown = $(document).scrollTop();
		if ((lastScrollLeft < documentScrollLeft || lastScrollDown < documentScrollDown) && (documentScrollLeft > 150 || documentScrollDown > 150)) {
			if(!$('header').hasClass('hide') && !$('.main-menu').hasClass('open-menu') && !$('.booking').hasClass('open') ){
				$('header').addClass('hide');
				$('.floatings').addClass('show');
			}
		}else{
			if($('header').hasClass('hide')){
				$('header').removeClass('hide');
				$('.floatings').removeClass('show');
			}
		}
		
		lastScrollLeft = documentScrollLeft;
		lastScrollDown = documentScrollDown;
	}
	
	var bshow = true;
	var bremove = true;
	function showFloatingButton(){
		var documentScLeft = $(document).scrollLeft();
		var lastScDown = $(document).scrollTop();
		var desktop = (viewport().width > 991)? 1 : 0;

		if(desktop){
			if(documentScLeft > 150 && bshow){
				$('.floatings').addClass('show');
				bshow = false;
				bremove = true;
			}else if(documentScLeft <= 150 && bremove){
				$('.floatings').removeClass('show');
				bremove = false;
				bshow = true;
			}
		}else{
			if(lastScDown > 500 && bshow){
				$('.scrollbutton').addClass('fixedBottom');
				bshow = false;
				bremove = true;
			}else if(lastScDown <= 500 && bremove){
				$('.scrollbutton').removeClass('fixedBottom');
				bremove = false;
				bshow = true;
			}
		}
	}

	function cookiesShow(){
		if($(window).scrollTop() == $(document).height() - $(window).height()){
			$('#cookie-button').show();
		}else{
			$('#cookie-button').hide();
		}
	}

	function triggerLightGallery(){
		$('.openGal').on('click', function(e){
			e.preventDefault();
			var galId = $(this).attr('data-galid'); // pridobi ustrezno galerijo za sklop glede na id vrstnega reda
			$(`.lightgallery.gal-${galId} a:first-child`).trigger("click");
		});
	}
	triggerLightGallery();
	
	
	$('input:text').textBoxHint(); // titles to input text
	$("article a, ul.grouped-link-list a").markExternalLinks(); // adds class to external links


	/* Wait for the whole page to load, including images. */
	$(window).load(function () {
		if(navigator.userAgent.indexOf("Chrome-Lighthouse") == -1){
			$('head').append('<link type="text/css" rel="stylesheet" href="/lib/lightgal/lightgallery.min.css" />');
			/*if($('#boka-map').length){
				$('head').append('<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAoYO67nTPLuORno-F58_zN_PUa8Q55m8Q&callback=initMap" async></script>');
			}*/
			$('body').append('<script type="text/javascript" src="/lib/nicescroll.min.js"></script>');
			$('body').append('<script src="/lib/lightgal/lightgallery.min.js"></script>');
			loadNiceScroll();
			$('.lightgallery').lightGallery();
		}
	});


	$(window).scroll(function() {
		hideMenuBar();
		showFloatingButton();
		cookiesShow();
		stopStartVideo();
	});


	/* --- window resizing --- */

	$(window).on('resize', function () {
		// resize and/or reposition elements here
		fixMobileTables();
		setSpecialOffer();
		loadNiceScroll();
	});
});


//mail decode
var mDec = function mDec(ensl, enlsShow, addToHref, insertHtml) {
	if (enlsShow == undefined || enlsShow == "") {
		enlsShow = ensl;
	}

	if (addToHref == undefined) {
		addToHref = "";
	}

	let a = "pdlowr=" + ensl;
	let nslv = "";
	for (let i = 0; i < a.length; i++) {
		let n = a.charCodeAt(i) - 3;
		nslv += String.fromCharCode(n);
	}

	let s = "";
	for (let i = 0; i < enlsShow.length; i++) {
		let n = enlsShow.charCodeAt(i);
		if (n >= 35 && n <= 126) {
			s += String.fromCharCode(n - 3);
		} else {
			s += enlsShow.charAt(i);
		}
	}

	if (insertHtml == '') {
		insertHtml = s;
	}

	document.write("<a class=\"email\" href=\"" + nslv + addToHref + "\">" + insertHtml + "</a>");
};
window.map = map;
window.urlDirFull = urlDirFull;
window.pageLng = pageLng;
window.initilizeLanguageSettings = initilizeLanguageSettings;
window.viewport = viewport;
window.mDec = mDec;
}.call(window, window);